const model = {
    submitting: false,
    errors: null,
    unitDetails: null,
    success: false,
};

export default model;
